import { useEffect } from 'react';
import { useCanDeactivate } from '@app/shared/hooks/useCanDeactivate';
import { useWizard } from '../../wizard/hooks/useWizard';
import { DestinationStorageKeys } from '../constants/storageKeys';
import { useCreateDestinationStateMachine } from './state-machine/useCreateDestinationStateMachine';
import { Wizard } from '../../wizard/Wizard/Wizard';
import { useConfirm } from '../../modal/ConfirmModal/useConfirm';
import { DiscardChangesConfirmModalBody } from '../../shared/components/DiscardChangesConfirmModalBody/DiscardChangesConfirmModalBody';

export default function CreateDestination() {
  const {
    wizardState,
    createWizard,
    currentStep,
    stepTreeSnapshot,
    stepGroups,
    wizardCompleted,
    selectStepGroup,
    currentStepFooterProps,
    onBackClick,
    onCancelClick
  } = useWizard({
    onComplete: () => {},
    cancelUrl: '/destination?tab=edge',
    isCancelUrlPathRelative: true
  });

  const stateMachine = useCreateDestinationStateMachine();
  const { confirm } = useConfirm();

  useEffect(() => {
    createWizard({
      stepsHeader: {
        for: '',
        title: 'Add Destination',
        id: 'add-destination',
        children: []
      },
      options: {
        trackingOptions: {
          storageKey: DestinationStorageKeys.ADD_DESTINATION
        }
      },
      stateMachine
    });
  }, []);

  const cancel = () => {
    onCancelClick();
  };

  useCanDeactivate(
    () =>
      !wizardCompleted
        ? confirm({
            title: 'Discard Changes',
            negativeButtonText: "Don't Discard",
            positiveButtonText: 'Discard',
            BodyComponent: DiscardChangesConfirmModalBody
          }).then(confirmed => confirmed as boolean)
        : true,
    () => !!wizardCompleted
  );

  return (
    <Wizard
      wizardState={wizardState}
      currentStep={currentStep}
      stepGroups={stepGroups}
      stepTreeSnapshot={stepTreeSnapshot}
      currentStepFooterProps={currentStepFooterProps}
      onBackClick={onBackClick}
      onCancelClick={cancel}
      selectStepGroup={selectStepGroup}
      WizardHeaderLeftComponent={Left}
      trackingProps={{
        wizard: 'DESTINATION_CREATE'
      }}
    />
  );
}

function Left() {
  return (
    <span className='text-subheading-2' data-id='create-destination-wizard-header-left'>
      Create Destination
    </span>
  );
}
